<template>
    <div class="tile-content">
        <div class="transaction-summary-timeline">
            <div v-for="event in timeline"
                 class="transaction-summary-timeline-event"
                 :class="{'is-active': event === transactionStatus}">
                {{ event | unKebabCase | capitalize }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'transaction-summary-timeline',
        props: {
            transactionStatus: {
                type: String,
            },
        },
        data() {
            return {
                events: {
                    pending: ['pending', 'sending', 'completed'],
                    sending: ['pending', 'sending', 'completed'],
                    completed: ['pending', 'sending', 'completed'],
                    timeout: ['pending', 'sending', 'timeout'],
                    'connection-error': ['pending', 'sending', 'connection-error'],
                    'never-sent': ['pending', 'sending', 'never-sent'],
                    'waiting-capture': ['pending', 'sending', 'waiting-capture', 'completed'],
                    'waiting-refund': ['pending', 'sending', 'waiting-refund', 'completed'],
                    'waiting-approval': ['pending', 'sending', 'waiting-approval', 'completed'],
                    suspended: ['pending', 'sending', 'suspended', 'completed'],
                    refunded: ['pending', 'sending', 'completed', 'refunded'],
                    'partially-refunded': ['pending', 'sending', 'completed', 'partially-refunded'],
                    disputed: ['pending', 'sending', 'completed', 'disputed'],
                },
            };
        },
        computed: {
            timeline() {
                return this.events[this.transactionStatus];
            },
        },
    };
</script>
